import React, { useMemo } from 'react';
import { CommentButtonAction, PostActionButtons } from '@components/Feed/Post/ActionButtons';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type {
  FeedPostActionsInfoFragmentDoc,
  FragmentType,
  UserActivityDetailFragmentDoc,
} from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { webappUriPath } from '@utils/url';
import { PostHeader } from './PostHeader';

export function TrendingPostItem({
  postFrag,
  creatorFrag,
  children,
  webappUri,
  postId,
  createdAt,
  content,
}: {
  postFrag: FragmentType<FeedPostActionsInfoFragmentDoc>;
  creatorFrag: FragmentType<UserActivityDetailFragmentDoc>;
  children: React.ReactNode;
  webappUri: string;
  postId: string;
  createdAt: string;
  content: React.ReactNode;
}) {
  const timestamp = useMemo(() => new Date(createdAt).getTime(), [createdAt]);

  return (
    <div className="-ml-3 cursor-pointer rounded-lg p-3 hover:bg-neutral50">
      <AccessibleLink
        pathnameUri={webappUriPath(webappUri)}
        className="before:absolute before:bottom-0 before:left-0 before:right-0 before:top-0 before:content-['']"
        onClick={() => {
          trackClickEvent({
            event: 'Post Link Clicked',
            properties: {
              associationId: postId,
              associationType: 'Post',
              sourceComponent: 'Feed Post',
            },
          });
        }}
      />
      <div className="flex flex-col gap-2">
        <PostHeader
          userFrag={creatorFrag}
          timestamp={timestamp}
          showFeedCuratorBadge
          className="z-above1 w-fit"
        />
        <div className="whitespace-normal">{content}</div>
        {children}
        <PostActionButtons
          postFrag={postFrag}
          commentButtonAction={CommentButtonAction.ShowModal}
          resourceOwnerTwitterHandle={null}
          sourceLocation="Post Feed Card"
          hideShareButton
          hideRepostButton={false}
          containerClassName="pl-3 -ml-3 gap-3 z-above1 w-fit"
          buttonClassName="p-1 -ml-1"
          iconSize={18}
          source="Post Feed Card"
          repostSource={null}
        />
      </div>
    </div>
  );
}
